import { ArrowBendUpRight, CheckCircle, XCircle } from "@phosphor-icons/react";

import { Tag, type TagVariantType } from "common/components/ui/Tag";
import type { Member } from "common/types";

import type { JSX } from "react";

export default function MemberStatusTag({
  memberStatus,
  memberRole,
  size,
}: {
  memberStatus: Member["status"];
  memberRole: Member["role"];
  size: "sm" | "md";
}) {
  if (memberRole === "owner") {
    return "-";
  }
  let icon: JSX.Element;
  let label: string;
  let variant: TagVariantType;

  if (memberStatus === "pending") {
    label = "Invite sent";
    variant = "tertiary";
    icon = <ArrowBendUpRight className="text-black-500" />;
  } else if (memberStatus === "rejected") {
    label = "Declined";
    variant = "disabled";
    icon = <XCircle className="text-black-400" />;
  } else {
    label = "Accepted";
    variant = "tertiary";
    icon = <CheckCircle weight="fill" className="text-green-500" />;
  }
  return (
    <Tag variant={variant} leftIcon={icon} size={size}>
      {label}
    </Tag>
  );
}
